import React, { Component, PropTypes } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Input, Table, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { VendSystems } from '././vendSystems';
import classnames from 'classnames';
import moment from 'moment';

export class VendIntegrations extends Component {
    static displayName = VendIntegrations.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            loadInt: false,
            intActive: null,
            tableData: [],
            sysData: [],
            tabActive: null
        }
        this.getIntData();
        if (this.props.renderSource == null) {
            this.getSysList();
        }
    }

    async getIntData() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userData.level,
            syspk: this.props.intpk === null ? "BLANK" : this.props.intpk
        }
        const response = await fetch('GetIntegrations', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data
        }, () => { if (this.props.renderSource != null) { this.setState({loadInt: true}) } })
    }

    async getSysList() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userData.level,
            vendorpk: ""
        }
        const response = await fetch('GetVendorSystems', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            sysData: data
        })
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.intpk !== this.props.intpk) {
            this.getIntData();
        }
    }

    tabToggle(tab) {
        if (this.state.tabActive !== tab) {
            this.setState({
                tabActive: tab
            });
        }
    }

    displayInt() {
        let intData = this.state.tableData
        if (this.state.intActive !== null) {
            intData = this.state.tableData.filter(f => {
                return f.parentpk === this.state.intActive || f.childpk === this.state.intActive
            })
        }
        console.log("mapping through: " + JSON.stringify(intData));
        console.log("base state: " + JSON.stringify(this.state.tableData));
        return (
            <div>
                <Table>
                    <thead>
                        <tr>
                            <th>"Parent" system</th>
                            <th>"Child" system</th>
                            <th>Two-Way Integration?</th>
                            <th>Integration Method</th>
                            <th>Integration Description</th>
                            <th>Documentation Location</th>
                        </tr>
                    </thead>
                    <tbody>
                        {intData.map(item => (
                            <tr>
                                <td>{item.sysparent}</td>
                                <td>{item.syschild}</td>
                                <td>{item.twoway}</td>
                                <td>{item.methodname}</td>
                                <td>{item.descrip}</td>
                                <td>{item.documentation}</td>
                            </tr>
                        )) }
                    </tbody>
                </Table>
                <br />
                <Nav tabs>
                    {this.props.renderSource !== "sys" &&
                        <NavItem>
                            <NavLink className={classnames({ active: this.state.tabActive === '1' })} onClick={() => this.tabToggle('1')}>Systems</NavLink>
                        </NavItem>
                    }
                </Nav>
                <TabContent activeTab={this.state.tabActive}>
                    {this.props.renderSource !== "sys" &&
                        <TabPane tabId='1'>
                            <div className="vendorChild"><VendSystems renderSource={"int"} userData={this.props.userData} syspk={this.state.intActive} /></div>
                        </TabPane>
                    }
                </TabContent>
            </div>
        );
    }

    render() {
        let pageRender = <div></div>
        if (this.state.loadInt === true) { pageRender = this.displayInt(); }
        return (<div>
            {this.props.renderSource === null && <h2>Integrations</h2>}<p />
            {this.props.renderSource === null && <Input type="select" name="intselect" id="intselect" defaultValue="DEFAULT" onChange={(e) => this.setState({ intActive: e.target.value, loadInt: true })}>
                <option value="DEFAULT" disabled>Select Root System...</option>
                {this.state.sysData.map(item => (
                    <option value={item.pk}>{item.sysname}</option>
                ))}
            </Input>}
            <br />
            {pageRender}
        </div>)
    }
}